// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"UserFormPane_formWrapper__v1Yry","formButtonWrapper":"UserFormPane_formButtonWrapper__1U4Q9"};